<template>
  <DxPopup @hidden="onHidden" :visible="bomPop" :show-close-button="true" :show-title="true" :title="'Detail BOM List Control'" :height= window.heights  :width= window.widths container=".v-application">
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-vertical :headerTitle="'BOM List'"
          :useBtnList="useBtnList"
          @btnClose="btnClose"
        >
          <template v-slot:body>
            <v-layout column >
              <v-row no-gutters>
                <v-col cols="12" class="pt-1">
                  <DxDataGrid id="v80o1020BomPop"
                    :ref="v80o1020BomPopRef"
                    :height= window.heightDx
                    :data-source="gridMainList" 
                    :remote-operations="false" 
                    :hover-state-enabled="true"
                    :allow-column-resizing="true" 
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true" 
                    :show-borders="true" 
                    :width="grid.width"
                    :show-row-lines="true" 
                    key-expr="id" 
                    :focused-row-enabled="false"
                    :column-hiding-enabled="false"
                    :word-wrap-enabled="true"
                    :selection="{mode:'none'}"
                  >
                    <DxColumn data-field="no" caption="No" width="3%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="shipNo" caption="Ship No" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="block" caption="block" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="partSpec" caption="Part specification" width="50%" data-type="string" alignment="left" :allow-editing="false" />
                    <DxColumn data-field="partNo" caption="Part No" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="matlUnit" caption="Matl. Unit" width="7%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="partQty" width="5%" data-type="string" alignment="center" :allow-editing="false"  header-cell-template="partQty"/>
                    <template #partQty >
                      <div>Part<br>Q'ty</div>
                    </template>

                    <DxColumn data-field="makerNm" caption="Sub-Contract Name" width="25%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="resNm" caption="Result Inspection" width="10%" data-type="string" alignment="center" :allow-editing="false" />

                    <DxPaging :enabled="true" :page-size="19" />
                    <DxPager :visible="true"  :showInfo="false" />
                  </DxDataGrid>
                  <span style="font-weight: bold;">Count Total: {{ totalRow }} Row(s)</span>
                </v-col>
              </v-row>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </DxPopup>
</template>

<script>
import { DxPopup } from 'devextreme-vue/popup';
import { DxDataGrid, DxEditing, DxColumn , DxPager ,DxLookup } from 'devextreme-vue/data-grid'
import DxDateBox from 'devextreme-vue/date-box'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import { v80o1020BomDtl } from '@/api/view/hip/8/v80o1020Popup.js'

export default {
  name: 'v80o1020BomPop',
  mixins: [baseview, BaseDataGrid],
  components: {
    DxPopup,
    ICardVertical,
    iCardTop,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPager,
    DxDateBox,
    DxLookup
  },
  props: {
    bomPop: {
      type: Boolean,
      default() { return false }
    },
    popupData: {
      type: Array,
      default() { return }
    },

  },
  data() {
    return {
      useBtnList: ['btnClose'],
      v80o1020BomPopRef: 'v80o1020BomPopRef',
      gridMainList: [],
      totalRow: 0,

      window: {
            widths: 0,
            heights: 0,
            heightDx: 0
      }

    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.v80o1020BomPopRef)
    },
  },
  watch: {
    'bomPop': {
      handler(value, oldValue) {
        if(value) {

          this.doSearchMain()
          window.addEventListener('resize', this.handleResize);
          window.removeEventListener('resize', this.handleResize);
          this.handleResize();
        }
      },
      immediate: true
    }
  },

  mounted(){
    this.gridMainInstance.option('defaultPaging', false)
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    // this.doSearchMain()
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  }, 
  methods: {
    onHidden(e) {
      this.$emit('update:bomPop', false)
    },
    handleResize() {
      this.window.widths = window.innerWidth - 250;
      this.window.heights = window.innerHeight - 100;
      this.window.heightDx = window.innerHeight - 250;
    },
    async doSearchMain(){
      this.gridMainList = []
      this.totalRow = 0

      let params = {
        shipNo: this.popupData.shipNo,
        makerCd: this.popupData.makerCd,
        inspAct: this.popupData.inspAct,
        revNo: this.popupData.revNo,
        porNo: this.popupData.porNo,
        porSeq: this.popupData.porSeq,
        reqDate: this.popupData.reqDate
      }
      try {
        this.openLoading('searching')
        await v80o1020BomDtl(params).then(res => {
          if(res.list.length){
            let cnt = 1
            res.list.forEach(e => {
              e.no = cnt
              e.id = cnt++
            });
            this.gridMainList = res.list
            this.totalRow = res.list.length
          }
        })
      } finally {
        this.endLoading()
      }
    },
    btnClose(){
      this.onHidden()
    },
    cellPrepared(e){
      if(e.rowType === 'data'){
        e.cellElement.style.padding = '0px'
      }
    },
  },
}
</script>

<style lang="scss" scoped>

</style>